export function required(fieldName, vtf) {
  var message = vtf.lang.translator("validations.required", fieldName);
  return v => !!v || message;
}

export function len(length, fieldName, vtf) {
  var message = vtf.lang.translator("validations.len", fieldName, length);
  return v => (!!v && v.length == length) || message;
}

export function min(minLength, fieldName, vtf) {
  var message = vtf.lang.translator("validations.min", fieldName, minLength);
  return v => (!!v && v.length >= minLength) || message;
}

export function max(maxLength, fieldName, vtf) {
  var message = vtf.lang.translator("validations.max", fieldName, maxLength);
  return v => (!!v && v.length <= maxLength) || message;
}

export function maxFileSize(size, fieldName, vtf) {
  var sizeInMB = (size / (1024 * 1024)).toFixed(2);
  var message = vtf.lang.translator(
    "validations.maxFileSize",
    fieldName,
    sizeInMB
  );
  return v => !v || v.size <= size || message;
}

export function sameValue(field1Name, field2Name, field2Value, vtf) {
  var message = vtf.lang.translator(
    "validations.sameValue",
    field1Name,
    field2Name
  );
  return v => (!!v && v === field2Value) || message;
}
